const PREFIX = 'api'
export const API_URL = `${process.env.VUE_APP_API_URL}/${PREFIX}`

export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 25
